/** The renderer is reused by CRM, which does not load the website's global CSS. */
export const PROPOSAL_DOCUMENT_PRINT_CSS = `
@media print {
  @page { size: A4; margin: 12mm; }
  /* auto, not page: a forced break after a scope that spilt two lines printed a near-blank page (1 Nov 2026). The same rule is in both print .astro pages. */
  .proposal-print .print-page { break-before: auto; }
  .proposal-print .print-page h2 { break-after: avoid; }
  .proposal-document { max-width: 100%; print-color-adjust: exact; -webkit-print-color-adjust: exact; }
  .proposal-document .proposal-document-summary { position: static !important; margin-left: 0 !important; margin-right: 0 !important; padding-left: 0 !important; padding-right: 0 !important; backdrop-filter: none !important; }
  .proposal-document .proposal-no-print { display: none !important; }
  .proposal-document .proposal-levels-print { font-size: 14px; line-height: 1.45; }
  .proposal-document .proposal-levels-print h2 { font-size: 22px; line-height: 1.2; }
  .proposal-document .proposal-levels-print h3 { break-after: avoid; }
  .proposal-document .proposal-levels-print section { margin-top: 5mm; margin-bottom: 5mm; }
  .proposal-document .proposal-levels-print header { padding: 5mm; break-inside: avoid; }
  .proposal-document .proposal-levels-print header h1 { font-size: 26px; line-height: 1.2; }
  .proposal-document .proposal-levels-print section, .proposal-document .proposal-scope-continuation { break-inside: auto; }
  .proposal-document .proposal-levels-print nav { display: none; }
  .proposal-document figure, .proposal-document table { break-inside: avoid; }
  .proposal-document .proposal-document-price, .proposal-document tr, .proposal-document .proposal-work-steps li { break-inside: avoid; }
  .proposal-document .proposal-work-steps { grid-template-columns: 1fr; }
  .proposal-document .proposal-document-price { break-inside: auto; break-after: avoid; }
  .proposal-document .proposal-document-price table { break-inside: auto; }
  .proposal-document .proposal-document-price td { padding-top: 4px; padding-bottom: 4px; }
  .proposal-document footer { break-before: avoid; break-inside: auto; }
  .proposal-document figcaption, .proposal-document h2 { break-after: avoid; }
  .proposal-document svg { max-width: 100%; max-height: 110mm; }
}`;
